module.exports = __webpack_public_path__ + "static/media/8OLA18.ff4da8a9.jpg";